<template>
  <v-container class="home-page d-flex justify-center align-center">
    <v-col cols="12" class="text-center">
      <div class="home-hero-layout">
        <!-- Left Info Stack -->
        <div class="home-info-stack home-info-stack-left">
          <v-card class="home-info-card" elevation="3">
            <v-card-text>
              <div class="home-info-icon">
                <v-icon icon="mdi-leaf-circle-outline" size="30" />
              </div>

              <h2>Willkommen bei EARNS</h2>

              <p>
                EARNS unterstützt Sie dabei, Energieeffizienzmaßnahmen für Projekte
                strukturiert zu erfassen, zu bewerten und nachvollziehbar zu analysieren.
              </p>
            </v-card-text>
          </v-card>

          <v-card class="home-info-card" elevation="3">
            <v-card-text>
              <div class="home-info-icon">
                <v-icon icon="mdi-timeline-check-outline" size="30" />
              </div>

              <h2>Effizienz im Projektverlauf</h2>

              <p>
                Behalten Sie Maßnahmen, Berechnungen und Projektdaten zentral im Blick —
                von der ersten Idee bis zur Auswertung.
              </p>
            </v-card-text>
          </v-card>
        </div>

        <!-- Image Section -->
        <v-sheet
          class="home-image-sheet d-flex justify-center align-center mb-6"
          elevation="0"
        >
          <v-img
            class="home-image"
            :src=home
            alt="ROM Technik Earns The Energy Efficiency Toolbox"
          />
        </v-sheet>

        <!-- Right Info Stack -->
        <div class="home-info-stack home-info-stack-right">
          <v-card class="home-info-card" elevation="3">
            <v-card-text>
              <div class="home-info-icon">
                <v-icon icon="mdi-finance" size="30" />
              </div>

              <h2>Transparente Bewertung</h2>

              <p>
                Vergleichen Sie Maßnahmen anhand technischer, energetischer und
                wirtschaftlicher Kennwerte - Jahressummen.
              </p>
            </v-card-text>
          </v-card>

          <v-card class="home-info-card" elevation="3">
            <v-card-text>
              <div class="home-info-icon">
                <v-icon icon="mdi-chart-line" size="30" />
              </div>

              <h2>Projekte effizient steuern</h2>

              <p>
                Erstellen Sie neue Projekte, verwalten Sie Maßnahmen und analysieren Sie
                Potenziale direkt im Webtool.
              </p>
            </v-card-text>
          </v-card>
        </div>
      </div>

      <!-- Buttons -->
      <div class="home-actions">
        <v-btn
          v-if="isLoggedIn"
          class="home-action-btn"
          @click="showProjects"
          color="primary"
          size="large"
        >
          <v-icon start>mdi-view-list</v-icon>
          Projekte
        </v-btn>

        <v-btn
          v-if="isLoggedIn"
          class="home-action-btn"
          @click="createProject"
          color="primary"
          size="large"
        >
          <v-icon start>mdi-database-plus</v-icon>
          Neues Projekt
        </v-btn>

        <v-btn
          class="home-action-btn"
          @click="showAbout"
          color="primary"
          variant="tonal"
          size="large"
        >
          <v-icon start>mdi-information</v-icon>
          Über EARNS
        </v-btn>
      </div>
    </v-col>
  </v-container>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useProjectStore } from '@/stores/projectStore'
import home from '@/assets/home.png'

const router = useRouter()
const store = useProjectStore()

const isLoggedIn = computed(() => store.isLoggedIn)

const showProjects = () => {
  router.push({ name: 'ProjectList' })
}

const createProject = () => {
  router.push({ name: 'NewProject' })
}

const showAbout = () => {
  router.push({ name: 'About' })
}
</script>

<style scoped lang="scss">
.home-page {
  min-height: 80vh;
}

.home-hero-layout {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
}

.home-image-sheet {
  position: relative;
  z-index: 1;

  width: 100%;
  max-width: 1100px;
  margin-inline: auto;
  min-height: 420px;
  max-height: 62vh;

  background-color: transparent;
  border-radius: 28px;
  overflow: hidden;

  transition:
      transform 220ms ease,
      box-shadow 220ms ease,
      z-index 220ms ease,
      filter 220ms ease;

}

.home-image-sheet:hover {
  // z-index: 6;
  // transform: scale(1.015);

  border: 1px solid rgba(var(--v-theme-primary), 0.08);


  box-shadow:
      0 0 0 10px rgba(var(--v-theme-primary), 0.06),
      0 24px 48px rgba(0, 52, 99, 0.18),
      0 10px 22px rgba(0, 0, 0, 0.14);

}

.home-image {
  width: 100%;
  height: 100%;
  min-height: 420px;
  max-height: 62vh;
  opacity: 1;

  transition:
      filter 220ms ease,
      transform 220ms ease;

}

// .home-image:hover {
//   z-index: 6;
//   transform: scale(1.015);
//   border: 1px solid rgba(var(--v-theme-primary), 0.08);

//   box-shadow:
//       0 0 0 10px rgba(var(--v-theme-primary), 0.06),
//       0 24px 48px rgba(0, 52, 99, 0.18),
//       0 10px 22px rgba(0, 0, 0, 0.14);

// }

.home-image-sheet:hover .home-image {
  filter: saturate(1.04) contrast(1.02);
}


.home-image :deep(.v-img__img) {
  border-radius: 28px;
}

/* Info card stacks */
.home-info-stack {
  position: absolute;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.home-info-stack-left {
  left: clamp(1rem, 4vw, 6rem);
  // top: 46%;
  // transform: translateY(-50%);

}

.home-info-stack-right {
  right: clamp(1rem, 4vw, 6rem);
  // top: 56%;
  // transform: translateY(-50%);

}

.home-info-card {
  position: relative;
  z-index: 2;

  width: 220px;
  border-radius: 28px;
  background-color: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  text-align: left;
  border: 1px solid rgba(var(--v-theme-primary), 0.08);

  transition:
      transform 220ms ease,
      box-shadow 220ms ease,
      border-color 220ms ease,
      z-index 220ms ease;

}

.home-info-card:hover {
  z-index: 8;
  transform: translateY(-6px) scale(1.03);
  border-color: rgba(var(--v-theme-primary), 0.24);
  box-shadow:
    0 18px 36px rgba(0, 0, 0, 0.18),
    0 8px 16px rgba(0, 0, 0, 0.12);
}


.home-info-card h2 {
  color: rgb(var(--v-theme-primary));
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.65rem;
}

.home-info-card p {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.5;
}

.home-info-icon {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.85rem;
  color: rgb(var(--v-theme-primary));
  background-color: rgba(var(--v-theme-primary), 0.08);
}

/* Buttons */
.home-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem 1.5rem;
  flex-wrap: wrap;
}

.home-action-btn {
  min-width: 170px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
}

/* Medium screens */
@media (max-width: 1500px) {
  .home-info-card {
    width: 200px;
  }

  .home-info-card h2 {
    font-size: 0.95rem;
  }

  .home-info-card p {
    font-size: 0.82rem;
  }

  .home-info-icon {
    width: 40px;
    height: 40px;
  }
}

/* Stack cards on smaller screens */
@media (max-width: 1250px) {
  .home-hero-layout {
    display: block;
  }

  .home-info-stack {
    position: static;
    width: min(100%, 720px);
    margin: 0 auto 1rem;
  }

  .home-info-card {
    width: 100%;
  }

  .home-image-sheet {
    margin-bottom: 1rem;
  }
}

/* Small screens */
@media (max-width: 700px) {
  .home-page {
    min-height: auto;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .home-image-sheet {
    min-height: 240px;
    max-height: 42vh;
  }

  .home-image {
    min-height: 240px;
    max-height: 42vh;
  }

  .home-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .home-action-btn {
    width: 100%;
  }
}
</style>
